import React from "react";
import { BsGoogle, BsTwitter } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { BsFillPersonFill } from "react-icons/bs";
import { RiLockPasswordFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";

const Login = () => {
  return (
    <div className="container lg:w-1/2 mx-auto py-5">
      <div className="bg-gradient-to-r to-[#f59a61] from-[#f5695d] text-gray-500 rounded-3xl shadow-xl w-full overflow-hidden">
        <div className="flex justify-center w-full">
          <div className="flex-row justify-center items-center py-5 px-5 md:px-10">
            <div className="text-center mb-3">
              <h1 className="font-bold text-3xl text-gray-700">LOGIN</h1>
              <p className="text-gray-700">Enter your credential to login</p>
            </div>
            <form>
              <div>
                <div className="flex -mx-3">
                  <div className="w-full px-3 mb-3">
                    <label
                      for="s-mail"
                      className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                    >
                      username
                    </label>
                    <div className="flex">
                      <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                        <BsFillPersonFill className="text-gray-400 text-lg" />
                      </div>
                      <input
                        type="text"
                        className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                        placeholder="@saibaba"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="flex -mx-3">
                  <div className="w-full px-3 mb-3">
                    <label
                      for="password"
                      className="block text-gray-700 font-bold mb-1 md:mb-0 pr-4 text-left"
                    >
                      Password
                    </label>
                    <div className="flex">
                      <div className="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center">
                        <RiLockPasswordFill className="text-gray-400 text-lg" />
                      </div>
                      <input
                        type="password"
                        className="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-700"
                        placeholder="************"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="flex -mx-3">
                  <div className="w-full px-3">
                    <input
                      className="block w-full max-w-xs mx-auto bg-btn-sec hover:bg-nav-gradient-from focus:bg-nav-gradient-from text-white rounded-lg px-3 py-3 font-semibold"
                      type="submit"
                      value="Login"
                    />
                  </div>
                </div>
              </div>
            </form>
            {/*Sign-up with social media*/}
            <div className="flex flex-col items-center justify-center lg:justify-start pt-3">
              <p className="block text-gray-700 font-bold md:text-right mb-2 md:mb-0">
                or
              </p>
              <p className="block text-gray-700 font-bold md:text-right mb-2 md:mb-0">
                Sign in with
              </p>
              <div className="flex flex-row">
                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="mx-auto h-9 w-9 rounded-full bg-btn-sec uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-nav-gradient-from focus:bg-nav-gradient-from focus:outline-none focus:ring-0 active:bg-primary-700"
                >
                  <BsGoogle className="inline align-middle" />
                </button>
                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="mx-1 h-9 w-9 rounded-full bg-btn-sec uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-nav-gradient-from focus:bg-nav-gradient-from focus:outline-none focus:ring-0 active:bg-primary-700"
                >
                  <FaFacebookF className="inline align-middle" />
                </button>

                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="mx-1 h-9 w-9 rounded-full bg-btn-sec uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-nav-gradient-from focus:bg-nav-gradient-from focus:outline-none focus:ring-0 active:bg-primary-700"
                >
                  <BsTwitter className="inline align-middle" />
                </button>
              </div>
            </div>
            ;
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
